<template>
  <expansion-section-block
    :title="$t('sections.room')"
    :subtitle="getRoomName(extendedRoom.roomId) || $t('form.selector_values.NO_ROOM')">
    <template v-slot:body>
      <v-row>
        <v-col cols="6" class="pb-0">
          <v-autocomplete :label="$t('form.room')"
            :items="filteredRoomList"
            item-text="name"
            item-value="id"
            v-model="roomId">
            <template v-slot:selection="{ item }">
              {{ item === selectorValues.NO_ROOM ? $t('form.selector_values.NO_ROOM') : item.name }}
            </template>
            <template v-slot:item="{ item }">
              {{ item === selectorValues.NO_ROOM ? $t('form.selector_values.NO_ROOM') : item.name }}
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <!-- GUESTS -->
      <edit-guest
        v-for="(guest, index) in extendedRoom.guests"
        :key="guest.id"
        :guest="guest"
        :showErrors="showErrors"
        @input="g => updateGuest(g, index)">
      </edit-guest>
    </template>
  </expansion-section-block>
</template>
<script>
import { mapGetters } from 'vuex'
import { selectorValues } from '@/config'
export default {
  props: {
    extendedRoom: Object,
    filteredRoomList: Array,
    showErrors: Boolean
  },
  data () {
    return {
      selectorValues: selectorValues,
      edited: {
        roomId: null
      }
    }
  },
  methods: {
    updateGuest (guest, index) {
      this.extendedRoom.guests[index] = guest
    }
  },
  computed: {
    ...mapGetters('rooms', ['getRoomName', 'getFirstFilteredRoomId']),
    editedRoom () {
      const room = this.extendedRoom
      room.roomId = this.roomId
      return room
    },
    roomId:{
      get () {
        return this.edited.roomId || this.extendedRoom.roomId
      },
      set (value) {
        this.edited.roomId = value
        this.$emit('input', this.editedRoom)
      }
    }
  },
  components: {
    EditGuest: () => import('@/components/view-components/EditGuest.vue'),
    ExpansionSectionBlock: () => import('@/components/ExpansionSectionBlock.vue')
  }
}
</script>